// sort actions


export function SortNew(listType) {
    return {
        type: 'sort/SORT_NEW',
        listType: listType
    };
}

export function SortOld(listType) {
    return {
        type: 'sort/SORT_OLD',
        listType: listType

    };
}

export function SortAtoZ(listType) {
    return {
        type: 'sort/SORT_AZ',
        listType: listType
    };
}


// filter actions

const sortFunctions = {
    'SortNew': SortNew,
    'SortOld': SortOld,
    'SortAtoZ': SortAtoZ,
};

export function FilterNone(listType, curSort) {
    return (dispatch) => {
        dispatch({
            type: 'filter/NO_FILTER',
            listType: listType
        });

        if (sortFunctions[curSort]) {
            dispatch(sortFunctions[curSort](listType));
        }
    };
}

export function FilterJobs(listType, filterOptions, curSort) {
    return (dispatch) => {

        dispatch({

            type: 'filter/FILTER_JOBS',
            listType: listType,
            filterOptions: filterOptions
        });

        if (sortFunctions[curSort]) {

            dispatch(sortFunctions[curSort](listType));
        }
    };
}


// job listing actions

export function JobListUnassigned() {
    return {
        type: 'jobList/UNASSIGNED'
    };
}

export function JobListAssigned() {
    return {
        type: 'jobList/ASSIGNED'
    };
}

export function JobListCompleted() {
    return {
        type: 'jobList/COMPLETED'
    };
}


// job list skimming actions

export function JobListSkimUpdate() {
    return {
        type: 'jobListSkim/UPDATE'
    };
}


// installer listing actions

export function InstallerListUpdate() {
    return {
        type: 'installerList/UPDATE'
    };
}

// account listing actions
export function accountListUpdate() {
    return {
        type: 'accountList/UPDATE'
    };
}
export function InstallerListSortbyAvailability(date, events) {
    return {
        type: 'installerList/SORT_AVAILABILITY',
        date: date,
        events: events
    };
}

export function InstallerListVehicleEventsUpdate() {
    return {
        type: 'installerListVehicleEvents/UPDATE',
    };
}

export function InstallerListVehicleEventsSingle(installerID, event) {
    return {
        type: 'installerListVehicleEvents/INSTALLER',
        installerID: installerID,
        event: event,
    };
}

export function InstallerListVehicleEventsNewEvent(installerID, event) {
    return {
        type: 'installerListVehicleEvents/NEW_EVENT',
        installerID: installerID,
        event: event,
    };
}

export function InstallerListVehicleEventsDeleteEvent(event) {
    return {
        type: 'installerListVehicleEvents/DELETE_EVENT',
        event: event,
    };
}

export function VehicleListAssociatedWithJob(jobId) {
    return {
        type: 'vehicleList/VEHICLE_ASSOCIATED_JOB',
        jobId: jobId,        
    };
}

export function VehicleListUpdate() {
    return {
        type: 'vehicleList/UPDATE',
    };
}

export function jobAssigned(listType, job) {
   
    return {
        type: 'job/ASSIGNED',
        job: job,
        listType: listType
    };
}
